<template>
    <div class="personal-cabinet tmp-block no-line">
        <h2>
            <span>Кабинет игрока. </span>
            <span class="fade">Твоя статистика на сервере, топ самых крутых игроков и еще много всего.</span>
        </h2>
        <router-link :to="{name: 'profile'}">
            <a href="#" class="linker enter">Войти в кабинет</a>
        </router-link>
        <div class="image-cover">
            <div class="image-content">
                <div class="battle-icon icon-holder">
                    <img src="@/assets/icons/battle-icon.svg" alt="">
                </div>
                <div class="add-icon icon-holder">
                    <img src="@/assets/icons/add-icon.svg" alt="">
                </div>
                <img class="on-edge pc-only" src="@/assets/screens/personal_cabinet/desktop_main_image.jpg" alt="">
                <img class="on-edge pc-hide" src="@/assets/screens/personal_cabinet/mobile_main_image.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from "vuex";

    export default {
        name: "personal_cabinet",

        computed:{
            ...mapGetters('window',['pcVersion'])
        }
    }
</script>

<style scoped lang="scss">
    .personal-cabinet{
        padding: 32px !important;
        a.enter{
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 32px !important;
        }
        .image-cover{

            margin: -32px;
            margin-top: 32px;

            .image-content{

                border-radius: 0 0 4px 4px;
                position: relative;
                overflow: hidden;
            }

            .icon-holder{
                position: absolute;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px;
            }

            .battle-icon{
                width: 52px;
                height: 52px;
                top: 35px;
                right: 32px;

                opacity: 0.94;
                filter: blur(4px);
                background: $orange;
                box-shadow: 0 16px 32px rgba(255, 169, 39, 0.32), inset -8px 8px 12px #FFCB51, inset 8px -6px 8px #F48600, inset 0px 0px 6px rgba(255, 255, 255, 0.32);
            }
            .add-icon{
                width: 76px;
                height: 76px;
                left: -10px;
                bottom: -28px;

                filter: blur(7px);
                background: $green;
                box-shadow: 0 16px 32px rgba(0, 194, 125, 0.32), inset -8px 8px 12px rgba(75, 236, 179, 0.72), inset 8px -6px 8px rgba(12, 160, 108, 0.84), inset 0px 0px 6px rgba(255, 255, 255, 0.32);
            }

            img.on-edge{
                display: block;
                width: calc(100% + 64px);
                max-height: 300px;

                object-fit: contain;
            }
        }

        @include mobile{
            padding: 24px !important;
            padding-top: 48px !important;
            h2{
                margin-bottom: 12px !important;
                font-size: 20px;
            }
            img.on-edge{
                width: calc(100% + 48px);
                margin: 24px -24px 0;
                border-radius: 0 0 4px 4px;
            }
        }
    }
</style>
